import { jsx as c } from "react/jsx-runtime";
import { c as m } from "../../../index-Cu0xwYjD.js";
import { useState as d, useEffect as p } from "react";
import '../../../assets/Stretch.css';const w = "_stretch_1b7gr_5", h = {
  stretch: w
}, S = ({
  children: r,
  className: o,
  defaultWidth: i,
  fullWidth: t
}) => {
  const [n, l] = d(!1);
  p(() => {
    const a = getComputedStyle(document.body).getPropertyValue(
      "--el-core-breakpoint-small"
    ), e = () => {
      l(window.innerWidth <= parseFloat(a));
    };
    return window.addEventListener("resize", e), e(), () => window.removeEventListener("resize", e);
  }, []);
  const s = t || n && t !== !1;
  return /* @__PURE__ */ c(
    "div",
    {
      className: m(h.stretch, o),
      style: {
        "--is-full-width": s ? 1 : 0,
        "--wrapper-width": s ? "100%" : i
      },
      children: r
    }
  );
};
export {
  S as Stretch
};
